// extracted by mini-css-extract-plugin
export var avatarContainer = "_hr-0";
export var avatarTypingWave = "_hr-i";
export var gray = "_hr-f";
export var green = "_hr-c";
export var icon = "_hr-9";
export var image = "_hr-1";
export var lg = "_hr-6";
export var md = "_hr-5";
export var presenceDot = "_hr-b";
export var red = "_hr-d";
export var sm = "_hr-4";
export var status = "_hr-a";
export var typingDot = "_hr-h";
export var typingPill = "_hr-g";
export var xl = "_hr-7";
export var xs = "_hr-3";
export var xxl = "_hr-8";
export var xxs = "_hr-2";
export var yellow = "_hr-e";